// Key-value settings.

import { db } from './db';

export async function getSetting<T>(key: string): Promise<T | undefined> {
  const row = await db.settings.get(key);
  return row === undefined ? undefined : (row.value as T);
}

export async function setSetting(key: string, value: unknown): Promise<void> {
  await db.settings.put({ key, value });
}

// The key names live in setting-keys.ts, which imports nothing — so the entry
// chunk can name a setting without pulling Dexie in behind it. Re-exported here
// because this is where every other caller already looks for them.
export {
  SETTING_LANGUAGE,
  SETTING_STAFF_SERVER,
  SETTING_STAFF_SESSION,
  SETTING_USER_PHONE,
} from './setting-keys';
